<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">

    </ion-buttons>
    <ion-title>
      <ion-icon name="accessibility"></ion-icon>
    </ion-title>
    <ion-buttons slot="end">
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <ion-grid class="banner">
    <ion-row>
      <ion-col class="ion-align-self-center margintop"><ion-label class="banner-title">Frequently Asked
          Questions</ion-label></ion-col>
    </ion-row>
  </ion-grid>
  <ion-list>
    <ion-list>
      <ion-item>
        <div class="help">
          <p><b>
              <h2>Application</h2>
            </b></p>
          <p><span><b>How do I create a new Checklist?</b></span></p>
          <p><span>Click on the <b>New</b> button (<ion-icon name="person-add"></ion-icon>) on the top right corner of
              the screen.<p></p></span></p>
          <p>Complete the following sections ensuring that all mandatory fields are completed. (“<span
              class="spanRed"><b>*</b></span>”
            denotes mandatory field)</p>

          <p><span>
              <p>&nbsp;</p>
            </span></p>

          <p><b><u><span>Organisation Information<p></p></span></u></b></p>
          <p><span>Captures the organisational structure and the event/activity profile.<p></p></span></p>

          <p class="pMarging"><b><i>Organisation Type<span class="spanRed">*</span>:</i></b><span> Describes
              the intended audience for the application. </span><i><span>(ie
                Australian Football League (AFL) / Cricket Australia)</span></i><span>
              <p></p>
            </span></p>

          <p class="pMarging"><b><i>Sub Type<span class="spanRed">*</span>: </i></b><span></span><span>Describes the
              risk/activity profile and the type of information that will be collected.<p></p></span></p>

          <p class="pMarging">
            <b>
              <i>Association Name<span class="spanRed">*</span>: </i>
            </b>
            <span>
              The name of the association that the club belongs to. <br>
              The name of your association will be automatically filtered and populated based on the (at least three) characters that you have entered in the text field and your state.
            </span>
            <br>
            <span>
              <b>
                <i>Note:</i>
              </b>
              If you cannot find your association you can just enter the name of your association manually.
            </span>
          </p>

          <p class="pMarging">
            <b>
              <i>Club Name<span class="spanRed">*</span>: </i>
            </b>
            <span>
              The name of the club belonging to association. <br>
              The name of your club will be automatically filtered and populated based on the (at least three) characters that you have entered in the text field and the association that you have selected.
            </span>
            <br>
            <span>
              <b>
                <i>Note:</i>
              </b>
              If you cannot find your club you can just enter the name of your club manually.
            </span>
          </p>

          <p class="pMarging"><b><i>Inspection Date Time<span class="spanRed">*</span>: </i></b><span>The Date that the
              inspection took place.<p></p></span></p>
          <p>Click on the <b>Next</b> button (<ion-icon name="chevron-forward-outline"></ion-icon>) on the top right
            corner of the screen.</p>

          <p><span>
              <p>&nbsp;</p>
            </span></p>

          <p><b><u><span>Address
                  Information<p></p></span></u></b></p>

          <p><span>Captures the address
              information of the event/activity.<p></p></span></p>

          <p class="pMarging"><b><i>Address Type<span class="spanRed">*</span>: </i></b><span> The
              location type of where the event will take place.<p></p></span></p>

          <p class="pMarging"><b><i>Venue<span class="spanRed">*</span>:</i></b><span> Venue of the location
              where the event will take place<p></p></span></p>

          <p class="pMarging"><b><i><span>Address:</span></i></b><span> Specific
              Address of the location where the event will take place.<p></p></span></p>

          <p class="pMarging"><b><i><span>Post Code:</span></i></b><span> Post
              Code of the location where the event will take place. <p></p></span></p>

          <p class="pMarging"><b><i><span>State<span class="spanRed">*</span>: </span></i></b>
            <span>State
              where the event will take place. </span><i><span>(derived if post code has
                been entered)</span></i><span>
              <p></p>
            </span>
          </p>

          <p class="pMarging"><b><i><span>Comments:</span></i></b><span> Any
              additional comments to describe the location where the event will take place<p></p></span></p>
          <p>Additional addresses can be added to the list as required.</p>
          <p><u>Note:</u> The first address is the primary address that will be displayed on the email
            and documents.</p>
          <p> Click on the <b>Next</b> button (<ion-icon name="chevron-forward-outline"></ion-icon>) on the top right
            corner of the screen</p>
          <p><span>
              <p>&nbsp;</p>
            </span></p>

          <p><b><u><span>Parties<p></p></span></u></b></p>

          <p><span>Captures the key
              parties/stakeholders that will participate in the event/activity.<p></p></span></p>

          <p class="pMarging"><b><i><span>Home Team <p></p></span></i></b></p>

          <p class="margin-left-72pt"><b><i><span>Name<span class="spanRed">*</span>: </span></i></b><span>
            </span><span>Name of the entity that is hosting the event<p></p></span></p>

          <p class="pMarging"><b><i><span>Hom Team Representative <p></p></span></i></b></p>

          <p class="margin-left-72pt"><b><i><span>Name<span class="spanRed">*</span>:
                </span></i></b><span></span><span>Name of the representative that is representing the hosting entity.<p>
              </p>
            </span></p>

          <p class="margin-left-72pt"><b><i><span>Position<span class="spanRed">*</span>:
                </span></i></b><span>Position of the
              representative that is representing the hosting entity.<b><i>
                  <p></p>
                </i></b></span></p>

          <p class="margin-left-72pt"><b><i><span>Email<span class="spanRed">*</span>: </span></i></b><span>Email of
              the
              representative that is representing the hosting entity. <b><i>
                  <p></p>
                </i></b></span></p>

          <p class="margin-left-72pt"><b><i><span>Comment: </span></i></b><span>Any
              supporting information regarding the hosting representative.<b><i>
                  <p></p>
                </i></b></span></p>

          <p class="pMarging"><span>
              <p>&nbsp;</p>
            </span></p>

          <p class="pMarging"><b><i><span>Away Team <p></p></span></i></b></p>

          <p class="margin-left-72pt"><b><i><span>Name<span class="spanRed">*</span>: </span></i></b><span>
            </span><span>Name of the entity that is
              hosted as part of the event<p></p></span></p>

          <p class="pMarging"><b><i><span>Away Team Representative <p></p></span></i></b></p>

          <p class="margin-left-72pt"><b><i><span>Name<span class="spanRed">*</span>: </span></i></b><span>
            </span><span>Name of the representative that is representing the hosted entity.<p></p></span></p>

          <p class="margin-left-72pt"><b><i><span>Position<span class="spanRed">*</span>:
                </span></i></b><span>Position of the
              representative that is representing the hosted entity.<b><i>
                  <p></p>
                </i></b></span></p>

          <p class="margin-left-72pt"><b><i><span>Email<span class="spanRed">*</span>: </span></i></b><span>Email of
              the
              representative that is representing the hosted entity.<b><i>
                  <p></p>
                </i></b></span></p>

          <p class="margin-left-72pt"><b><i><span>Comment: </span></i></b><span>Any supporting information regarding
              the hosted representative.<p></p></span></p>
          <p><span>Additional Parties can be added to the list as required.<p></p></span></p>
          <p><span><u>Note</u>: Completed documents will be dispatched to all emails
              provided.</span></p>
          <p>Click on the <b>Next</b> button (<ion-icon name="chevron-forward-outline"></ion-icon>) on the top right
            corner of the screen.</p>

          <p><i><span>
                <p>&nbsp;</p>
              </span></i></p>

          <p><b><u><span>Risk<p></p></span></u></b></p>

          <p>
            <span>Capture the risk profile of the event based on the hazard and exposure criterion.</span>
          </p>

          <p class="pMarging">
            <b>
              <i>
                <span>Question: </span>
              </i>
            </b>
            <span>
              Risk questions
              pertaining to a hazard and exposure criterion, based on entity
              and organisation profile.
            </span>
          </p>

          <p class="pMarging">
            <b>
              <i>
                <span>Comment<span class="spanRed">*</span>: </span>
              </i>
            </b>
            <span> Additional
              information pertaining
              to the risk
              is and methodologies in place to mitigate the hazard and exposure. Only
              mandatory if hazard or exposure is present.
            </span>
          </p>

          <p class="pMarging">
            <b>
              <i>
                <span>Image: </span>
              </i>
            </b>
            <span> Additional image (photo/image) may be attached to the relevant comment (one image per comment). <br>
              It is recommended that images are attached in landscape mode.<br>
              (Note that attachments are resized and compressed size and format sensitive requiring the user to abide by the application requirements)  
              <p>Total attachment size cannot be greater than 4MB, with each image ideally being less then 1MB in size. Only image JPG/JPEG, PNG, BMP are supported.</p>
            </span>
          </p>

          <p>
            Click on the <b>Next</b> button (<ion-icon name="chevron-forward-outline"></ion-icon>) on the top right
            corner of the screen.
          </p>

          <p><span>
              <p>&nbsp;</p>
            </span></p>

          <p><b><u><span>Declaration<p></p></span></u></b></p>

          <p><span>Confirmation of the
              declared information captured and submitted is true and agreed upon both
              hosting and hosted representatives. <p></p></span></p>

          <p><span>The generated document
              will be primarily dispatched to both representatives and any email addresses
              specified in the <span>parties</span> section.<p></p></span></p>

          <p>Click on the <b>Submit</b> button on the bottom of the screen.</p>

          <p>Once the checklist has been submitted it will be visible in read only capacity on the Checklist/Main Page.</p>

          <p>If no further checklist need to be submitted the user can exit the application.</p>

          <p><span>
              <ol>&nbsp;</ol>
            </span></p>
          <p><span>This completes the process and brings the user to the main checklist page
              where they are able to see their submitted checklists. <p></p></span></p>
          <p><span>At this point the user may exit the application by clicking on the <b>Exit</b> button (<ion-icon
                name="exit"></ion-icon>) <p></p></span></p>

          <p><span>
              <ol>&nbsp;</ol>
            </span></p>

          <p><span><b>What happens once I submit the information?</b></span></p>
          <p>Once a checklist has been submitted it becomes read only (<ion-icon name="eye-outline"></ion-icon>) and no
            further edits are possible.</p>

          <p>If the device has data connectivity it will send the information to service for processing.</p>

          <p class="pMarging">The service will acknowledge the request, the Process ID on the checklist page will be
            updated to a number
            (e.g., 1007985) from an alphanumeric code (e.g., 6528EFCG1DE2).</p>
          
          <p class="pMarging">Utilising the information in the request, the service will create the checklist document
             and send it to all email addresses listed in the Parties section.</p>

          <!-- <p class="pMarging">Using the information in the request service will generate the checklist document and
            email it to all email
            addresses provided in the Parties section.</p> -->

          <p>If the device does not have data connectivity it will store the request information on the device until
            data connectivity is restored. Once the data connectivity is restored</p>

          <p class="pMarging">A <b>Force Submit</b> button (<ion-icon name="share-outline"></ion-icon>) will appear next
            to each checklist allowing the user to force submit the request
            again.</p>

          <p>Click on the <b>Force Submit</b> button (<ion-icon name="share-outline"></ion-icon>) to force submit the
            checklist.</p>

          <p class="pMarging">Please allow for at least 10 minutes to receive the email and documentation.</p>
          <p><span>
              <p>&nbsp;</p>
            </span></p>

          <p>
            <span><b>How can I see the information on checklist?</b></span>
          </p>

          <p>If the checklist has been submitted a <b>View</b> button (<ion-icon name="eye-outline"></ion-icon>) will be
            visible this allows the user to see the
            information submitted part of the respective checklist.</p>


          <p>If the checklist has not been submitted users can click on the <b>Edit</b> button (<ion-icon
              name="create-outline"></ion-icon>) to navigate and edit unsubmitted
            checklist.</p>
          <p><span>
              <p>&nbsp;</p>
            </span></p>
          <p><span><b>Why can’t I edit/delete a checklist?</b></span></p>

          <p>Once a checklist has been submitted it can only be viewed (ie cannot be edited). Should you require to
            update any information on a submitted checklist, a new a new checklist will need to be created.</p>

          <p>Only unsubmitted checklist can be edited or deleted .</p>

          <p class="pMarging">Click on the <b>Edit</b> button (<ion-icon name="create-outline"></ion-icon>) to edit
            unsubmitted checklist.</p>

          <p class="pMarging">Click on the <b>Delete</b> button (<ion-icon name="trash-outline"></ion-icon>) to delete
            an unsubmitted checklist</p>
          <p><span>
              <p>&nbsp;</p>
            </span></p>

          <p><b><span>Why can’t I see the additional parties and addresses in the email.</span></b>
          </p>
          <p>Only the Primary (first) address and the Home Team Name, Home Team Representative and Away Team Name and
            Away Team Representative details are displayed on the checklist.</p>

          <p><span>
              <p>&nbsp;</p>
            </span></p>
          <p><b>
              <h2>Troubleshooting</h2>
            </b></p>

          <p>
            <b><span>I have submitted my checklist but have not received the email and documentation?</span></b>
          </p>
          <p>Depending on how busy the service is the dispatch of emails and respective documents may take up to 30
            minutes.</p>

          <p>To confirm that your checklist has been correctly submitted please ensure that</p>
          <ol>
            <li>
              <p>There is data connectivity either through your network provider or wifi</p>
            </li>
            <li>
              <p>On the checklist page the Process ID is a number (ie 1007985) not an alphanumeric code (ie
                6528EFCG1DE2)
            </li>
            <li>
              <p>The <b>Force Submit</b> button (<ion-icon name="share-outline"></ion-icon>) is <i>not</i> visible next
                to the <b>View</b> button (<ion-icon name="eye-outline"></ion-icon>) on the checklist</p>
              <p>(if <b>Force Submit</b> button (<ion-icon name="share-outline"></ion-icon>) exits click on the button
                to force submit the checklist)</p>
            </li>
          </ol>
          <p><span>
              <p>&nbsp;</p>
            </span></p>
          <p>
            <b><span>I have submitted a checklist but want the email to be sent to another party?</span></b>
          </p>
          <p>There is no functionality to recreate, resubmit or re email once checklist has been successfully submitted.
          </p>

          <p><span>
              <p>&nbsp;</p>
            </span></p>
          <p>
            <b><span>The application is not correctly showing some/all fields?</span></b>
          </p>
          <p>This may be due to several issues. We recommend the following steps:</p>
          <ol>
            <li>
              <p>Ensure that you have data connectivity</p>
              <p>(It is strongly recommended that the application is loaded at least once after the download)</p>
            </li>
            <li>
              <p>Ensure your device is not in <i>Dark Mode</i></p>
            </li>
            <li>
              <p>Try viewing the screen in landscape form</p>
            </li>
            <li>
              <p>Shut down and restart the application</p>
            </li>

            <li>
              <p>Check for new version of the application from your store</p>
            </li>

            <li>
              <p>Restart your device</p>
            </li>

            <li>
              <p>Reinstall the application</p>
            </li>
          </ol>
          <p>Note: Reinstalling the application will result in <u>loss all previously submitted checklist data</u> on
            the
            device.</p>

          <p><span>
              <p>&nbsp;</p>
            </span></p>


          <p>
            <b><span>I can't see any of my previously submitted checklists?</span></b>
          </p>
          <p>Clearing the application data/cache or reinstalling the application will result in <u>loss of all
              previously
              submitted checklist information</u>. Refer to your emails for a copy of the data.</p>

          <p><span>
              <p>&nbsp;</p>
            </span></p>
          <p><b>Contact Us</b></p>
          <p>Marsh helps protect many of Australia’s most loved national sports and helps hundreds of communities to
            manage risk and unlock possibility.</p>
          <p>Our websites also provide comprehensive information about the cover available under your program, and how
            to obtain insurance specific information.</p>
          <p><span>
              <p>&nbsp;</p>
            </span></p>
          <p>Marsh Sport Team</p>
          <p>Address: Marsh Pty Ltd | Collins Square, 727 Collins Street, Melbourne, Victoria 3008</p>
          <p>Telephone: <a href="tel:1300 130 373">1300 130 373</a></p>
          <p>Email: <a href="mailTo:sport@marsh.com">sport&#64;marsh.com</a></p>
          <p>Website: <a href="https://www.au.marsh.com/sport.html"><span>https://www.au.marsh.com/sport.html</span></a>
          </p>
        </div>
      </ion-item>
    </ion-list>
  </ion-list>
  <!-- Add build version and date at the bottom -->
  <p class="footer-build">
    <strong>Build Version:</strong>1.0.11<br>
    <strong>Date:</strong> 19 May 2025
  </p>